// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1BcuT","select":"Header_select__11HVX","clinic":"Header_clinic__1o8Sn"};